<script setup>
import { user } from "@/store";
import OfUserForm from "./OfUserForm.vue"
import OfButton from "@dk.onlinefundraising/vue-utils/src/utils/OfButton.vue";
import requests from "@/OfOnboardingRequests";
import { ref } from "vue";


const userData = ref({
    userGuid: user.value.guid,
    role: user.value.role,
    name: user.value.role,
    email: user.value.email,
    externalId: user.value.externalId,
})

function requestReset() {
    requests.requestPasswordReset(userData.value.userGuid);
}
function updateUser() {
    requests.updateUser(userData.value).then(result => {
        if (result) {
            user.value.guid = result.userGuid;
            user.value.role = result.role;
            user.value.name = result.name;
            user.value.email = result.email;
            user.value.externalId = result.externalId;
        }
    });
}
</script>
<template>

    <h2>Profile</h2>

    <OfUserForm :user="userData" />

    <OfButton coloring="primary" text="Update" @click="updateUser()" />

    <a @click.prevent="requestReset()">Request password reset</a>

</template>
<style scoped>
h2 {
    margin-bottom: 1rem;
}

a {
    display: block;
    margin-top: 1rem;
}
</style>